jQuery(document).ready(function($) { 

    let coinTableContainers = document.querySelectorAll('.ctp-coin-table-container');  

    // if there are some tables on the page
    if (coinTableContainers.length > 0) {       

        coinTableContainers.forEach(function(container) { 

            container.addEventListener('scroll', () => {
                const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth;
            
                if (isAtEnd) {
                    console.log('Scrolled to the end!');
                    // @todo  create script for removing shade on horizontal scroll
                }
            });

        });                     
    }
});     







